import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@services/baseQuery';
import { handleError } from '../../utils/api-error-handling';

export const keyApi = createApi({
  reducerPath: 'keyApi',
  baseQuery: baseQuery,
  tagTypes: ['key'],
  endpoints: (builder) => ({
    createKey: builder.mutation({
      query: (params) => ({
        url: `lockset/createKey/${params}`,
        method: 'POST',
      }),
      invalidatesTags: ['key'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
  }),
});

export const { useCreateKeyMutation } = keyApi;
